import styled from "styled-components";
import {
  ButtonBase,
  Card,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";

export const CardBody = styled(Card)`
  && {
    background: linear-gradient(90deg, #3cf0f1 0%, #03424a 100%);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
  }
`;

export const CardImage = styled(CardMedia)`
  && {
    width: 400px;
    height: 225px;
    object-fit: contain;
  }
`;

export const CardData = styled(CardContent)`
  && {
    background: #ffffff;
    border: 0.5px solid #c4c4c4;
    border-radius: 0px 0px 30px 30px;
    padding-bottom: 25px;
  }
`;

export const Title = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 44px;
    letter-spacing: 0.05em;
    color: #000000;
    margin-bottom: 45px;
  }
`;

export const Domain = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 0.05em;
    color: #ffffff;
    padding: 10px;
    width: fit-content;
    margin: auto;
    margin-bottom: -15px;
    position: relative;
    top: -35px;

    background: linear-gradient(90deg, #3cf0f1 0%, #03424a 100%);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
  }
`;

export const InternshipName = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0.05em;
    color: #000000;
    margin-bottom: 18px;
  }
`;

export const Tag = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 0.05em;
    color: #000000;
    padding: 9px 15px;

    background: #ffffff;
    border: 1.5px solid #c4c4c4;
    border-radius: 15px;
  }
`;

export const CtaButton = styled(ButtonBase)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;
